export const GENERIC_ERROR = "Something went wrong. Please try again later!";
export const STORY_NOT_FOUND_ERROR = "This story has been deleted.";
export const STORY_ALREADY_SHARED_ERROR = "This story has already been shared!";
export const VOICE_ERROR = "The application is having trouble right now. Try again in a moment!";

import { SettingsErrorCode, SubscriptionErrorCode, VpcErrorCode } from "@amzn/a4k-creator-studio-shared";

export const ACCESS_BLOCKED_TITLES: Record<string, string> = {
  [VpcErrorCode.NOT_GRANTED]: "Parental consent required to use this feature.",
  [SettingsErrorCode.DISABLED]: "Story Builder is turned off.",
  [SubscriptionErrorCode.NOT_SUBSCRIBED]: "Kids+ subscription required to use this feature.",
};
